import supportedBrowsers from 'shared/helpers/supportedBrowsers';

window.supportedBrowsers = supportedBrowsers;
